import React, { useContext, useEffect, useState } from "react";
import { Grid, Stack } from "@mui/material";
import NoImage from "../../../assets/No-Image-Placeholder.png";
import NoSignature from "../../../assets/no-signature.png";
import "../../../styles/Layout/_PersonalDetails.scss";
import { decrypt } from "../../../utils/encryptDecrypt";
import { fDate } from "../../../utils/formatTime";
import { getDate } from "../../../utils/helpers";
import { AuthContext } from "../../../context/AuthContext";

const PersonalDetails = (props) => {
  const { isFinal = false } = props;
  const [appliedPost, setAppliedPost] = useState([]);
  const [personalData, setPersonalData] = useState([]);
  const { setAlertState, setIsLoading } = useContext(AuthContext);

  useEffect(() => {
    if (Object.keys(props?.candidateData).length) {
      setIsLoading(true);
      const applied = props?.candidateData?.applied_post?.map((data) => {
        return data?.name;
      });
      const tempEmail = decrypt(props?.candidateData?.email);
      let email = "";
      if (tempEmail?.includes("@")) {
        const first = tempEmail?.split("@")[0];
        const second = tempEmail?.split("@")[1];
        let masked = "";
        for (let i = 3; i < first?.length; i++) {
          masked += "X";
        }
        email = `${first?.slice(0, 3)}${masked}@${second}`;
      }
      if (props?.title === "Confirm Payment Information and Pay") {
        setPersonalData([
          {
            name: "Candidate's Name",
            value: props?.candidateData?.name
              ? decrypt(props?.candidateData?.name)
              : "-",
          },
          {
            name: "Father's Name/Husband's Name",
            value: props?.candidateData?.father_name
              ? decrypt(props?.candidateData?.father_name)
              : "-",
          },
          {
            name: "Date of Birth",
            value: fDate(props?.candidateData?.dob, "dd/MM/yyyy"),
          },
          {
            name: "Category",
            value: props?.candidateData?.category,
          },
          {
            name: "Mobile No. ",
            value: props?.candidateData?.mobile
              ? `${decrypt(props?.candidateData?.mobile)?.slice(
                0,
                2
              )}XXXXX${decrypt(props?.candidateData?.mobile)?.slice(7)}`
              : "-",
          },
          {
            name: "Email Id",
            value: props?.candidateData?.email ? email : "-",
          },
          {
            name: "Total Amount Payable",
            value:
              "₹ " +
              ((props?.candidateData?.exam_fee + props?.candidateData?.exam_service_charge) || 0).toFixed(2),
          },
        ]);
        setIsLoading(false);
      } else {
        let age = "";
        (async () => {
          const response = await getDate(
            fDate(props?.candidateData?.dob),
            Number(
              props?.candidateData?.is_applied_against_last_exam_si_2022
            ) === 1
              ? "old"
              : "new"
          );
          if (response?.error) {
            setAlertState((prev) => ({
              ...prev,
              open: true,
              title: response?.msg,
              btnTxt: "CLOSE",
              status: "fail",
            }));
          } else {
            age = response?.age;
            if (isFinal) {
              setPersonalData([
                {
                  name: "Application Number",
                  value: props?.candidateData?.application_no,
                  bold: "600",
                },
                {
                  name: "Application Status",
                  value: Number(props?.candidateData?.application_status) === 1
                    ? props?.candidateData?.payment_status === "Success"
                      ? "Completed"
                      : "Incompleted"
                    : "Cancelled",
                  color:
                    Number(props?.candidateData?.application_status) === 1
                      ? props?.candidateData?.payment_status === "Success"
                        ? "#0044ff"
                        : "#ff3939"
                      : "#ff3939",
                  bold: "600",
                },
                {
                  name: "Candidate's Name",
                  value: props?.candidateData?.name
                    ? decrypt(props?.candidateData?.name)
                    : "-",
                },
                {
                  name: "Father's Name/Husband's Name",
                  value: props?.candidateData?.father_name
                    ? decrypt(props?.candidateData?.father_name)
                    : "-",
                },
                {
                  name: "Mother's Name",
                  value: props?.candidateData?.mother_name
                    ? decrypt(props?.candidateData?.mother_name)
                    : "-",
                },
                {
                  name: "Date of Birth",
                  value: fDate(props?.candidateData?.dob, "dd/MM/yyyy"),
                },
                {
                  name: `Age (As on ${Number(
                    props?.candidateData.is_applied_against_last_exam_si_2022
                  ) === 1
                    ? "01 Jul, 2021"
                    : "01 Jul, 2023"
                    })`,
                  value: age,
                },
                {
                  name: "Gender",
                  value:
                    props?.candidateData?.gender === "Female" ? (
                      <div className="personal-information--content">
                        {props?.candidateData?.gender}
                        {/* <p>
                          You are not eligible for Platoon Commander
                          (P.A.C./l.R.B.)
                        </p> */}
                      </div>
                    ) : (
                      props?.candidateData?.gender
                    ),
                },
                {
                  name: "Marital Status",
                  value: props?.candidateData?.marital_status,
                },
                {
                  name: "Email Id",
                  value: props?.candidateData?.email ? email : "-",
                },
                {
                  name: "Mobile No. ",
                  value: props?.candidateData?.mobile
                    ? `${decrypt(props?.candidateData?.mobile)?.slice(
                      0,
                      2
                    )}XXXXX${decrypt(props?.candidateData?.mobile)?.slice(7)}`
                    : "-",
                },
                {
                  name: "Place of filling form",
                  value: props?.candidateData?.application_filling_place,
                },
                {
                  name: "Domicile of Uttarakhand?",
                  value:
                    Number(props?.candidateData?.domicile) === 1 ? "Yes" : "No",
                },
              ]);
            } else {
              setPersonalData([
                {
                  name: "Application Status",
                  value: "Incomplete",
                  color: "#ea4d67",
                },
                {
                  name: "Candidate's Name",
                  value: props?.candidateData?.name
                    ? decrypt(props?.candidateData?.name)
                    : "-",
                },
                {
                  name: "Father's Name/Husband's Name",
                  value: props?.candidateData?.father_name
                    ? decrypt(props?.candidateData?.father_name)
                    : "-",
                },
                {
                  name: "Mother's Name",
                  value: props?.candidateData?.mother_name
                    ? decrypt(props?.candidateData?.mother_name)
                    : "-",
                },
                {
                  name: "Date of Birth",
                  value: fDate(props?.candidateData?.dob, "dd/MM/yyyy"),
                },
                {
                  name: `Age (As on ${Number(
                    props?.candidateData.is_applied_against_last_exam_si_2022
                  ) === 1
                    ? "01 Jul, 2021"
                    : "01 Jul, 2023"
                    })`,
                  value: age,
                },

                {
                  name: "Gender",
                  value:
                    props?.candidateData?.gender === "Female" ? (
                      <div className="personal-information--content">
                        {props?.candidateData?.gender}
                        {/* <p>
                          You are not eligible for Platoon Commander
                          (P.A.C./l.R.B.)
                        </p> */}
                      </div>
                    ) : (
                      props?.candidateData?.gender
                    ),
                },
                {
                  name: "Marital Status",
                  value: props?.candidateData?.marital_status,
                },
                {
                  name: "Email Id",
                  value: props?.candidateData?.email ? tempEmail : "-",
                },
                {
                  name: "Mobile No. ",
                  value: props?.candidateData?.mobile
                    ? `${decrypt(props?.candidateData?.mobile)}`
                    : "-",
                },
                {
                  name: "Place of filling form",
                  value: props?.candidateData?.application_filling_place,
                },
                {
                  name: "Domicile of Uttarakhand?",
                  value:
                    Number(props?.candidateData?.domicile) === 1 ? "Yes" : "No",
                },
              ]);
            }
          }
        })();
      }
      setAppliedPost(applied ? applied : []);
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.candidateData]);

  return (
    <fieldset className="personal-details--fieldset">
      <legend className="personal-details--legend">{props.title}</legend>
      {/* for web preview */}
      <div className="print-web">
        <Grid container spacing={3}>
          <Grid item lg={3} md={3} sm={3} xs={12}>
            <Stack
              direction="column"
              className="print-photo"
              spacing={3}
              alignItems={"center"}
            >
              <div className="personal-details--imgBox">
                <img
                  src={props?.candidateData?.candidate_image
                    ? props?.candidateData?.candidate_image
                    : NoImage}
                  alt="user"
                  className="personal-details--img"
                />
              </div>
              <div className="personal-details--signatureBox">
                <img
                  src={props?.candidateData?.candidate_signature
                    ? props?.candidateData?.candidate_signature
                    : NoSignature}
                  alt="signature"
                  className="personal-details--signature"
                />
              </div>
            </Stack>
          </Grid>
          <Grid item lg={9} md={9} sm={9} xs={12}>
            <Grid container spacing={2} className="print-details1">
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="personal-details--text">Exam Name</p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="personal-details--textSecondary">
                  {appliedPost.length > 0 ? appliedPost.toString() : '-'}
                </p>
              </Grid>

              {personalData.map((el, index) => {
                const newLocal = "personal-details--text";
                return (
                  <React.Fragment key={index}>
                    {el.name !== "" && (
                      <>
                        <Grid
                          item
                          lg={el?.col || 6}
                          md={el?.col || 6}
                          sm={el?.col || 6}
                          xs={12}
                        >
                          <p
                            className={newLocal}
                            style={{ color: el.colorName }}
                          >
                            {el.name}
                          </p>
                        </Grid>
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={6}
                          xs={12}
                          style={{ display: `${el?.display}` }}
                        >
                          <p
                            className="personal-details--subText"
                            style={{ color: el.color }}
                          >
                            {el.value}
                          </p>
                        </Grid>
                      </>
                    )}
                  </React.Fragment>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </div>
      {/* for print preview */}
      <div className="print-view">
        <Grid container spacing={1}>
          <Grid item lg={3} md={3} sm={3} xs={3}>
            <div className="print-photo w-100">
              <div className="personal-details--imgBox print-imgBox">
                <img
                  src={props?.candidateData?.candidate_image
                    ? props?.candidateData?.candidate_image
                    : NoImage}
                  alt="user"
                  className="personal-details--img printImg"
                />
              </div>
              <div className="personal-details--signatureBox">
                <div className="print-sign">
                  <img
                    src={props?.candidateData?.candidate_signature
                      ? props?.candidateData?.candidate_signature
                      : NoSignature}
                    alt="signature"
                    className="personal-details--signature printImgSign"
                  />
                </div>
              </div>
            </div>
          </Grid>
          <Grid item lg={9} md={9} sm={9} xs={9}>
            <div className="print-details1 d-flex">
              <div className="w-50">
                <p className="personal-details--text">Exam Name</p>
              </div>
              <div className="w-50">
                <p className="personal-details--textSecondary">
                  {appliedPost.length > 0 ? appliedPost.toString() : '-'}
                </p>
              </div>
            </div>

            {personalData.map((el) => {
              return (
                <>
                  {el.name !== "" && (
                    <div className="print-details1 d-flex">
                      <div className={`${el?.width ? el.width : "w-50"}`}>
                        <p
                          className="personal-details--text"
                          style={{ color: el.colorName }}
                        >
                          {el.name}
                        </p>
                      </div>
                      <div
                        className="w-50"
                        style={{ display: `${el?.display}` }}
                      >
                        <p
                          className="personal-details--subText"
                          style={{ color: el.color, fontWeight: el.bold }}
                        >
                          {el.value}
                        </p>
                      </div>
                    </div>
                  )}
                </>
              );
            })}
            <div className="print-view">
              <div className="print-details1 d-flex">
                <div className="w-50">
                  <p className="personal-details--text">Nationality</p>
                </div>
                <div className="w-50">
                  <p className="personal-details--subText">
                    {props?.candidateData?.nationality}
                  </p>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </fieldset>
  );
};

export default PersonalDetails;
